import React, { useContext } from 'react'
import styles from './BrandFeatures.module.scss'
import Marquee from 'react-fast-marquee'
import Type from '@/component/Primitive/Type'
import { ThemeContext } from '@/component/Context/ThemeContext'
import { useVersionPath } from '@/component/Context/VersionPathContext'

const BrandFeatures = () => {
  const { theme } = useContext(ThemeContext)
  const versionPath = useVersionPath()
  const features = [
    {
      label: 'Lists',
      src: `/public/image/brand/top-100/${theme}--top-100-white.png`
    },
    {
      label: 'Events',
      src: `/public/image/brand/live/${theme}--live-white.png`
    },
    {
      label: 'Webinars',
      src: `/public/image/brand/webinar/${theme}--webinar-white.png`
    },
    {
      label: 'Testimonials',
      src: `/public/image/brand/testimonial/${theme}--testimonial-white.png`
    },
    {
      label: 'Videos',
      src: `/public/image/brand/play/${theme}--play-white.png`
    },
    {
      label: 'Round Table',
      src: `/public/image/brand/round-table-series/${theme}--round-table-series-white.png`
    }
  ].map((feature) => ({ ...feature, src: versionPath(feature.src) }))

  return (
    <div className={styles.BrandFeatures}>
      <Marquee speed={60} gradient={false}>
        {features.map((feature, i) => (
          <div key={feature.label} className={styles.Feature}>
            <img
              className={styles.FeatureImage}
              src={feature.src}
              alt={feature.label}
              loading="lazy"
            />
            <Type
              className={styles.FeatureLabel}
              size={['body3', 'body1']}
              weight="regular"
            >
              {feature.label}
            </Type>
          </div>
        ))}
      </Marquee>
    </div>
  )
}

export default BrandFeatures
